import React, {useState} from "react";
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export default function Dia_Header() {

const [dialogOpen, setdialogOpen] = useState(false);
const handleDialogOpen = () => {setdialogOpen(true);};
const handleDialogClose = () => {setdialogOpen(false);};

return(
<>      
        <Button onClick={handleDialogOpen} variant="text" size="small" >
        <Typography variant="h6" color='text.background' gutterBottom 
                                sx={{fontWeight: '600', fontSize: {sx: '55%', sm: '45%', md: '75%', lg: '90%', xl: '170%' }, 
                      '&:hover': {fontSize: {sx: '55%', sm: '45%', md: '75%', lg: '90%', xl: '190%' },  color: 'tertiary.light'}, mb:2  }}>
                      ENDOCRINE
            </Typography>
        </Button>


            <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth='xl'
                    sx={{ '& .MuiDialogContent-root': { display: 'flex', flexDirection: 'column', m: 'auto', width: '100%',}, 
                          '& .MuiDialogActions-root': { padding: 1,},}}>

                                  <DialogTitle sx={{backgroundColor: 'background.default'}}>
                                        <Typography  variant='h3' color='primary' align= 'center' sx={{ fontWeight: '500', mt:4}} >
                                        ENDOCRINE SYSTEM<br /> CANCER TYPES
                                        </Typography>
                                  </DialogTitle>
                                  
                                  <DialogContent sx={{p:4, backgroundColor: 'background.default'}}>        
                                  
                                  
                                  <Typography  variant='h4' color='primary' align= 'left' sx={{fontWeight: '400', mt:4}} >                               
                                
                                    - Thyroid Cancer<br />
                                    - Adrenal Cancerr<br />
                                    - Pituitary Tumors<br />
                                  
                                    </Typography>

                                  </DialogContent>
                                  
                                  <DialogActions sx={{backgroundColor: 'background.default'}}>
                                      <Button onClick={handleDialogClose} sx={{m:4}}>BACK</Button>
                                  </DialogActions>
            </Dialog>



</>
)}